// console.log('global.js loaded');
const initToggleNavigation = () => {
	const navigation = document.querySelector('.wp-block-zp4-group.header-mobile-navigation');
	let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
	const openNavigationBtn = document.querySelector('.navigation-toggle-open');
	const closeNavigationBtn = document.querySelector('.navigation-toggle-close');
	const navigationBottom = document.querySelector('.wp-block-zp4-group.header-mobile-navigation');
	let lastFocusedElement;

	const mobile = 414;
	const tablet = 768;
	const laptop = 1024;
	const desktop = 1300;

	// Adds a class to the navigation-mobile when the viewport is less than 768px
	const updateNavigationClass = () => {
		if (viewportWidth < laptop) {
			navigation.classList.add('navigation-mobile');
		} else {
			navigation.classList.remove('navigation-mobile');
		}
	};
	updateNavigationClass();
	window.addEventListener('resize', () => {
		viewportWidth = window.innerWidth || document.documentElement.clientWidth;
		updateNavigationClass();
	});

	// Keep the events focusable within the navigation
	function trapFocus(event) {
		// const focusableArea = document.querySelector('.wp-block-zp4-group.header-mobile-navigation');
		const focusableElements = navigation.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
		const firstFocusableElement = focusableElements[0];
		const lastFocusableElement = focusableElements[focusableElements.length - 1];

		if (event.key === 'Tab') {
			if (event.shiftKey) {
				if (document.activeElement === firstFocusableElement) {
					event.preventDefault();
					lastFocusableElement.focus();
				}
			} else {
				if (document.activeElement === lastFocusableElement) {
					event.preventDefault();
					firstFocusableElement.focus();
				}
			}
		}
	}

	openNavigationBtn.addEventListener('click', function() {
		const isOpenExpanded = this.getAttribute('aria-expanded') === 'true';
		this.setAttribute('aria-expanded', !isOpenExpanded);
		lastFocusedElement = document.activeElement;
		navigation.addEventListener('keydown', trapFocus);
		navigation.classList.add('navigation-active');
		document.querySelector('body').classList.add('navigation-active');
		closeNavigationBtn.focus();
		navigationBottom.style.position = 'unset';
		// console.log('openNavigationBtn clicked');
	});

	closeNavigationBtn.addEventListener('click', function() {
		lastFocusedElement = document.activeElement;
		navigation.removeEventListener('keydown', trapFocus);
		navigation.classList.remove('navigation-active');
		document.querySelector('body').classList.remove('navigation-active');
		openNavigationBtn.focus();
		openNavigationBtn.setAttribute('aria-expanded', 'false');
		navigationBottom.style.position = '';
		// console.log('closeNavigationBtn clicked');
	});

	navigation.insertBefore(closeNavigationBtn, navigation.firstChild);
};

window.addEventListener('load', initToggleNavigation);
